import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';
import { NotificationToastService } from 'app/notification/notification-toast.service';

@Component({
  selector: 'app-manage-branch',
  templateUrl: './manage-branch.component.html',
  styleUrls: ['./manage-branch.component.css'],
  providers:[NotificationToastService, AngularFireDatabase]
})
export class ManageBranchComponent implements OnInit {

  private myForm: FormGroup;
  private userId:string;
  submitted : boolean = false;
  hasError : boolean ;
  editProfile = true;
  editProfileIcon = 'icofont-edit';
  branchData : Observable<any>;
  branch: any;

  constructor(private route: ActivatedRoute, public db:AngularFireDatabase, private nf: NotificationToastService) {
    var data = this.route.snapshot.queryParamMap.get('key');
    this.userId = data;
    this.initializeForm();
   }

  ngOnInit() {
    this.getUser();
  }

  initializeForm()
  {
    let name = new FormControl('', Validators.required);
      let address = new FormControl('', Validators.required);
      let phone = new FormControl('', Validators.required);
  
      this.myForm = new FormGroup({
        name:name,
        address:address,
        phone: phone,
      });

    this.edit();
    this.myForm.reset();
  }
  private edit()
  {
    this.db.object('/branches/' + this.userId)
    .subscribe(branch =>{
      let name = new FormControl(branch.name, Validators.required);
      let address = new FormControl(branch.address, Validators.required);
      let code = new FormControl(branch.code, Validators.required);
      let phone = new FormControl(branch.phoneNumber, Validators.required);
      let lat = new FormControl(branch.lat, Validators.required);
      let lng = new FormControl(branch.lng, Validators.required);
       // Assuming that name is a value of customer you can say
       this.myForm = new FormGroup({
        name:name,
        address:address,
        code:code,
        phone: phone,
        lat: lat,
        lng: lng
      });
      if(branch.code == "+966")
      {
        this.maxLength = 9;
        this.myForm.controls["phone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      }
      else
      {
        this.maxLength = 10;
        this.myForm.controls["phone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      }
    });
    
  } 
  phone_error:boolean = false;

  editAccount(name,key) {
   firebase.database().ref('financeExpenseCat').child(key).update({
     categoryName: name,
      branchId: key
    });
  }

  onSubmit()
  {
    this.hasError = false;
    this.submitted = true;
    var phone = this.myForm.value.phone;
    if(phone.length != this.maxLength)
      {
        this.phone_error = true;
        return;
      }
    else if(this.myForm.valid) {
      var usersRef = firebase.database().ref("branches");
      usersRef.child(this.userId).update({
        name: this.myForm.value.name,
        address: this.myForm.value.address,
        code: this.myForm.value.code,
        phoneNumber: this.myForm.value.phone,
        lat: this.myForm.value.lat,
        lng: this.myForm.value.lng
      }).then(
        (success) => {
          this.editAccount(this.myForm.value.name,this.branch.accountId);
          this.submitted = false;
          this.myForm.reset();
          this.nf.addToast({title:'Update Success', msg:'Branch data has been updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});   
          this.toggleEditProfile(); 
        });
    } 
  }
  toggleEditProfile() {
    this.editProfileIcon = (this.editProfileIcon === 'icofont-close') ? 'icofont-edit' : 'icofont-close';
    this.editProfile = !this.editProfile;
    if(this.editProfileIcon == 'icofont-edit')
      this.edit();
  }
  public getUser()
  {
    this.branchData = this.db.object("branches/"+this.userId);
    this.branchData.subscribe(branch=>{
      this.branch = branch;
    });
  }
  maxLength: number = 9;
  onChangeCountry(e)
  {
    this.phone_error = false;
    switch(e.target.value)
    {
      case "+91" : this.maxLength  = 10;
      this.myForm.controls["phone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      break;
      case "+966" : this.maxLength  = 9;
      this.myForm.controls["phone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      break;
    }
  }
  keyPress(event: any) {
    this.phone_error = false;
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    else
    {
      var phone = this.myForm.value.phone;
      if(phone.length >= this.maxLength)
      {
        event.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/branches/manage-branch/manage-branch.component.ts